import React from 'react';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useColorMode } from '../../contexts/ColorModeContext';

function ThemeToggle({ sx }) {
  const { mode, toggleColorMode } = useColorMode();
  const nextMode = mode === 'dark' ? 'light' : 'dark';

  return (
    <Tooltip title={`Switch to ${nextMode} mode`}>
      <IconButton
        aria-label={`Switch to ${nextMode} mode`}
        onClick={toggleColorMode}
        size="small"
        sx={{
          width: 38,
          height: 38,
          color: 'text.primary',
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.paper',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
          ...sx,
        }}
      >
        {mode === 'dark' ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
}

export default ThemeToggle;
